export const Pictures = 'DISPLAY_MODE_PICTURES';
export const Gifs = 'DISPLAY_MODE_GIFS';
export const CoolCats = 'DISPLAY_MODE_COOL_CATS';



// WEBPACK FOOTER //
// src/constants/displayMode.js